var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.automaticRound.secondsLeftUntilNext != null)?_c('v-chip',[_vm._v(" "+_vm._s(_vm.automaticRound.secondsLeftUntilNext)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }